import { render } from "./DataMain.vue?vue&type=template&id=42a70824"
import script from "./DataMain.vue?vue&type=script&lang=js"
export * from "./DataMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__